<template>
  <div id="signedData">
      <div id="right">
        <!-- 日期控件 -->
        <HeadControl titleName="签约数据" ref="HeadControl" @changeVal="changeVal" @changDate="changDate" @changePicker="changePicker"></HeadControl>
        <!-- 头部 -->
        <div class="inner-top" v-if="ContractInformation">
          <div class="item">
            <div class="l-box">
              <div class="l-t">签约合同额</div>
                <div class="l-a">{{AmountFormat(ContractInformation[0].amount)}}<span>元</span></div>
              </div>
              <div class="r-box">
                <img :src="ContractInformation[0].itemIcon" />
              </div>
          </div>
          <div class="item">
            <div class="l-box">
              <div class="l-t">合同回款额</div>
                <div class="l-a">{{AmountFormat(ContractInformation[1].amount)}}<span>元</span></div>
              </div>
              <div class="r-box">
                <img :src="ContractInformation[1].itemIcon" />
              </div>
          </div>
          <div class="item">
            <div class="l-box">
              <div class="l-t">签约合同个数</div>
                <div class="l-a">{{ContractInformation[2].count}}<span>个</span></div>
              </div>
              <div class="r-box">
                <img :src="ContractInformation[2].itemIcon" />
              </div>
          </div>
          <div class="item">
            <div class="l-box">
              <div class="l-t">签约合同人数</div>
                <div class="l-a">{{ContractInformation[3].count}}<span>人</span></div>
              </div>
              <div class="r-box">
                <img :src="ContractInformation[3].itemIcon" />
              </div>
          </div>
        </div>
        <!-- 中间 -->
        <div class="ceter-Box">
          <div class="left-Box" ref="ContractAmount"></div>
          <div class="right-Box" ref="ContractNumber"></div>
        </div>
        <!-- 底部 -->
        <signedDataEcharts @getDirectorRanking="getDirectorRanking"
        :screenWidth="screenWidth" :ProjectAreaList="ProjectAreaList" :DirectorRankingList="DirectorRankingList" :RankingProjectAmountList="RankingProjectAmountList" :ProjectTypeList="ProjectTypeList" :PieprojectTypeList="PieprojectTypeList" :CooperationTypeList="CooperationTypeList" :ProjectLevelList="ProjectLevelList"></signedDataEcharts>
    </div>
  </div>
</template>

<script>
import HeadControl from "@/components/HeadControl";
import signedDataEcharts from '@/components/ReportComponent/signedDataEcharts'
import * as Urls from '@/helper/Urls';
import {amountFormat,EchartsformatDate,checkDay,floatDiv,subStringNum} from '@/helper/VueHelper.js'
export default {
  components:{
    HeadControl,
    signedDataEcharts
  },
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽度
      orgCode:'',
      dataRange:[],
      ContractInformation:'', // 合同信息 
      ContractAmountList:'', // 合同额 
      ContractNumberList:'', // 合同个数
      ProjectTypeList:'', // 工程类型
      PieprojectTypeList:'', // 项目类型
      CooperationTypeList:'', // 合作类型
      ProjectLevelList:'', // 项目等级
      RankingProjectAmountList:'',// 项目金额排行
      DirectorRankingList:'', // 项目总监排行
      ProjectAreaList:'', // 项目地区
      Maxmoney:''
    };
  },
  mounted(){   
    let start = new Date();
    let end = new Date();
    start.setDate(1);
    start.setHours(0);
    start.setSeconds(0);
    start.setMinutes(0);
    start.setTime(start.getTime());
    this.dataRange = [this.$root.formatDay(start), this.$root.formatDay(end)];
    let _this = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth + 17; //实时宽度
        _this.screenWidth = window.screenWidth;
      })();
    }; 
  }, 
  methods:{
     init(){
       this.$refs.HeadControl.getDatas('month')
       this.$refs.HeadControl.getSysOrg()
     },
    // 获取组织架构ID
    changeVal(val) {
       this.orgCode = val 
       this.getContractAmount()
       this.getContractNumber()
       this.getProjectType()
       this.getPieprojectType()
       this.getCooperationType()
       this.getProjectLevel()
       this.getRankingProjectAmount()
       this.getDirectorRanking('AMOUNT')
       this.getProjectArea()
    },
    changDate(val){
       this.dataRange=val  
       this.getContractAmount()  
       this.getContractNumber()
       this.getProjectType()
       this.getPieprojectType()
       this.getCooperationType()
       this.getProjectLevel()
       this.getRankingProjectAmount()
       this.getDirectorRanking('AMOUNT')
       this.getProjectArea()
    },
    // 时间
    changePicker(val){
       this.dataRange = val  
       this.getContractAmount()   
       this.getContractNumber()  
       this.getProjectType()  
       this.getPieprojectType()
       this.getCooperationType()
       this.getProjectLevel()
       this.getRankingProjectAmount()
       this.getDirectorRanking('AMOUNT')
       this.getProjectArea()
    },
    getOrgCode(){
        this.$refs.HeadControl.getSysOrg()
    }, 
    // 金额转换
    AmountFormat(val){
      return amountFormat(val)
    },  
    // 获取合同额 + 合同信息 
    getContractAmount(){
      let _this = this
      let url = Urls.getEchartsSignedReportDataByInfo
      let params = {
          orgCode:this.orgCode,
          startTime:this.dataRange.length?this.dataRange[0]:'',
          endTime:this.dataRange.length?this.dataRange[1]:'',
          itemCode:'CONTRACT_MONEY'        
      }
      this.$root.doPost(url,params,function(server_data){
          // 用户没有登录
          if( !_this.$root.isUserLogin(server_data)){
          return;
        }

        // 应用错误
        if(server_data.error){
            _this.$root.showGlobalError(server_data.error);
            return;
        }
        _this.ContractInformation = server_data.data.reportList
        _this.ContractAmountList = server_data.data
      })      
    },
    // 合同额走势报表
    initChart(){
        let { legend,series,xAxis} = this.ContractAmountList
        // let Maxmoney = Math.max(...series[0].data,...series[1].data)
        let MaxMoneyLength = subStringNum(floatDiv(this.Maxmoney, 10000),2);
        let width = MaxMoneyLength.toString().length 
        let WidthPx = (width * 10) + 20
        let Chart = this.$echarts.getInstanceByDom(this.$refs.ContractAmount);
        if (Chart == null) {
          this.myChart = this.$echarts.init(this.$refs.ContractAmount);
        }      
        const option = {
                textStyle: {
                  fontFamily: 'PingFang-M'
                },
                  title:{
                    text: '合同额&回款额走势',
                    top:'24',  
                    left:this.$route.query.identification ? '20' : '30',
                    textStyle:{
                      fontWeight:500,
                    }
                  },      
                  grid: {
                    // left: this.screenWidth <=1366 ? WidthPx + 15 : WidthPx,
                    left:this.$route.query.identification ? '52' :'70',
                    right: this.$route.query.identification ? '48' : '30',
                    top:this.$route.query.identification ? '100' :  '100',
                    bottom:this.$route.query.identification ? '25' : '50',
                  },
                  tooltip: {
                    show: true,
                    trigger: "axis",  
                    formatter: function (params) {
                      let h = `<div style="padding: 5px 10px; font-size: 12px">`;
                      params.forEach(item => {
                        if (item.seriesIndex == 0) {
                          h += `<div >${EchartsformatDate(item.axisValue)}</div>
                                  <div><div>${item.marker}${item.seriesName}：${amountFormat(item.value)}元</div>
                                `
                        } else {
                          if (params.length == 1) {
                            h += `<div >${EchartsformatDate(item.axisValue)}</div>`
                          }
                          h += `<div>${item.marker}${item.seriesName}：${amountFormat(item.value)}元</div></div>`
                        }
                      });

                      return h;
                    },
                  axisPointer: {
                      lineStyle: {
                          color: '#DDDDDD',
                          type:'solid'
                      },
                  },                                               
                  },                
                  legend: {
                      show: true,
                      x: this.$route.query.identification ? '240' : '260',
                      y: this.$route.query.identification ? '18' : '26',
                      icon: 'circle',
                      itemGap:this.$route.query.identification ? 10 : 25,
                      itemWidth: 8,
                      itemHeight: 7,
                      textStyle: {
                          color: '#666666',
                          height: 10,
                          rich: {
                            a: {
                              verticalAlign: 'middle',
                          },
                        }
                      },
                      data: legend
                  },
                  xAxis: [{
                      type: 'category',
                      boundaryGap: 0,
                      axisLine: {
                      show: Math.max(...series[0].data,...series[1].data) == 0 ? true : false,
                      lineStyle: {
                        color: '#DDDDDD'
                      }
                    },
                    axisLabel: {
                      show:this.$route.query.identification ? false : true,
                      color: '#666666',
                      interval:this.screenWidth <=1366 || this.screenWidth == 1536  || checkDay(this.dataRange) < 30 ? 'auto' : Math.ceil( xAxis.data.length / 10),
                      padding:[8,0,0,0],
                    },
                    splitLine: {
                      show: Math.max(...series[0].data,...series[1].data) == 0 ? false : true,
                      lineStyle: {
                        color: '#DDDDDD',
                        type: 'solid'
                      }
                    },
                    axisTick: {
                      show: false
                    },
                    
                      data: xAxis.data
                  }],
                  yAxis: [{
                          type: 'value',
                          name: '金额(万)',
                          // min: 0,
                          // max: 100,
                          show:Math.max(...series[0].data,...series[1].data) == 0 ? false : true,
                          splitLine: {
                            show: Math.max(...series[0].data,...series[1].data) == 0 ? false : true,
                            lineStyle: {
                              color: '#DDDDDD',
                              type: 'solid'
                            }
                          },
                          axisLine: {
                            show: false
                          },
                          axisLabel: {
                            show: true,
                            textStyle: {
                              color: '#666666'
                            },
                            formatter: (params) => {
                              let res = floatDiv(params, 10000)
                              res.toFixed(2);
                              return Math.max(...series[0].data,...series[1].data) == 0 ? params : (params == 0 ? 0 : subStringNum(res, 2));
                            //  return Math.max(...series[1].data, ...series[1].data) == 0 ? params : (params / 10000);
                            }
                          },
                          axisTick: {
                            show: false
                          },
                            // 坐标轴名称的文字样式
                          nameTextStyle: {
                            align:'left',
                            // padding: [0, 0, 0, -20],
                            color:'#666666'
                          },
                      },
                  ],
                  series: [{
                          name: series[0].name,
                          type: 'line',
                          smooth:true,
                          symbolSize: 2,
                          showSymbol: false,
                          itemStyle: {
                              normal: {
                                  opacity: Math.max(...series[0].data) == 0 ? 0 : 1,
                                  color:'#5ebbff',
                                  lineStyle: {
                                      color: "#5ebbff",
                                      width: 2,
                                      opacity: Math.max(...series[0].data) == 0 ? 0 : 1
                                  },
                              }
                          },
                          areaStyle: {
                              normal: {
                                  color:'#e6f5ff',
                              }
                          },
                          data: series[0].data
                      },
                      {
                          name: series[1].name,
                          type: 'line',
                          smooth:true,
                          stack: '总量',
                          symbolSize: 2,
                          showSymbol: false,
                          itemStyle: {
                              normal: {
                                opacity: Math.max(...series[1].data) == 0 ? 0 : 1,
                                  color: '#72d8c0',
                                  lineStyle: {
                                      color: "#72d8c0",
                                      width: 2,
                                      opacity: Math.max(...series[1].data) == 0 ? 0 : 1,
                                  },
                              }
                          },
                          areaStyle: {
                              normal: {
                                color: '#cdedf2',
                              }
                          },
                          data: series[1].data
                      },
              
                  ]
                };
        this.myChart.setOption(option);
        window.addEventListener("resize", () => {
          if(this.$route.query.identification) {
            var resize = {
              width: this.screenWidth - 21,
            };
            this.myChart.resize(resize)
          } else {
            this.myChart.resize()
          }
        })  
    }, 
    // 获取合同个数  
    getContractNumber(){
      let _this = this
      let url = Urls.getEchartsSignedReportDataByInfo
      let params = {
          orgCode:this.orgCode,
          startTime:this.dataRange.length?this.dataRange[0]:'',
          endTime:this.dataRange.length?this.dataRange[1]:'',
          itemCode:'CONTRACT_NUMBER'        
      }
      this.$root.doPost(url,params,function(server_data){
          // 用户没有登录
          if( !_this.$root.isUserLogin(server_data)){
          return;
        }

        // 应用错误
        if(server_data.error){
            _this.$root.showGlobalError(server_data.error);
            return;
        }
        _this.ContractNumberList = server_data.data
      })       
    },
    // 合同个数走势报表  
    initChart1(){
      let { legend,series,xAxis} = this.ContractNumberList
      let Chart1 = this.$echarts.getInstanceByDom(this.$refs.ContractNumber);
      if (Chart1 == null) {
        this.myChart1 = this.$echarts.init(this.$refs.ContractNumber);
      }      
      const option = {
                textStyle: {
                  fontFamily: 'PingFang-M'
                },
                title:{
                  text: '合同个数&签约人数走势',
                  top:'24',  
                  left:this.$route.query.identification ? '20' : '30',
                  textStyle:{
                    fontWeight:500,
                  }
                },      
                grid: {
                    left: this.$route.query.identification ? '52' :'60',
                    right:this.$route.query.identification ? '48' :  '30',
                    top:this.$route.query.identification ? '100' :  '100',
                    bottom:this.$route.query.identification ? '25' : '50',                    
                },
                tooltip: {
                    show: true,
                    trigger: "axis",  
                    formatter: function (params) {
                     let h = `<div style="padding: 5px 10px; font-size: 12px">`;
                     params.forEach(item => {
                      if (item.seriesIndex == 0) {
                        h += `<div >${EchartsformatDate(item.axisValue)}</div>
                                <div><div>${item.marker}${item.seriesName}：${item.value}个</div>
                              `
                      } else {
                        if(params.length== 1 ){
                          h += `<div >${EchartsformatDate(item.axisValue)}</div>`
                        }
                        h += `<div>${item.marker}${item.seriesName}：${item.value}人</div></div>`
                      }
                      });                        
                        return h;
                  },
                  axisPointer: {
                      lineStyle: {
                          color: '#DDDDDD',
                          type:'solid'
                      },
                  },                                              
                },                
                legend: {
                  show: true,
                  x:this.$route.query.identification ? '240' : '290',
                  y:this.$route.query.identification ? '18' : '26',
                  icon: 'circle',
                  itemGap:this.$route.query.identification ? 10 : 25,
                  itemWidth: 8,
                  itemHeight: 7,
                  textStyle: {
                      color: '#666666',
                      height: 10,
                      rich: {
                        a: {
                          verticalAlign: 'middle',
                      },
                    }
                  },
                  data: legend
                },
                xAxis: [{
                    type: 'category',
                    boundaryGap: 0,
                     axisLine: {
                      show: Math.max(...series[0].data,...series[1].data) == 0 ? true : false,
                      lineStyle: {
                      color: '#DDDDDD'
                      }                    
                    },
                  axisLabel: {
                    show:this.$route.query.identification ? false : true,
                    color: '#666666',
                    interval:this.screenWidth <= 1366 || this.screenWidth == 1536  || checkDay(this.dataRange) < 30  ? "auto" : Math.ceil(xAxis.data.length / 10),
                    padding:[8,0,0,0]
                  },
                  splitLine: {
                    show:false,
                  },
                  axisTick: {
                    show: false
                  },
                    data: xAxis.data
                }],
                yAxis: [{
                        type: 'value',
                        name: '数量(个)',
                        minInterval:1, // 个数显示一个,无小数点
                        min: 0,
                        // max: Math.ceil(reportList[0].count/10)*10,  
                        //  interval: 'auto',
                       show:Math.max(...series[0].data, ...series[1].data) == 0 ? false : true,
                       splitLine: {
                        show: Math.max(...series[0].data,...series[1].data) == 0 ? false : true,
                        lineStyle: {
                          color: '#DDDDDD',
                          type: 'solid'
                        }
                      },
                      axisLine: {
                        show: false
                      },
                      axisLabel: {
                        show: true,
                        // padding:[2,2,2,2],
                        textStyle: {
                          color: '#666666'
            
                        }
                       },
                      axisTick: {
                        show: false
                       },
                      // 坐标轴名称的文字样式
                     nameTextStyle: {
                       align:'left',
                      //  padding: [0,15,0,0],
                       color: '#666666'
                     },
                    },
                ],
                series: [{
                        name: series[0].name,
                        type: 'line',
                        smooth:true,
                        symbolSize: 2,
                        showSymbol: false,
                        itemStyle: {
                            normal: {
                                opacity: Math.max(...series[0].data) == 0 ? 0 : 1,
                                color:'#5ebbff',
                                lineStyle: {
                                    color: "#5ebbff",
                                    width: 2,
                                    opacity: Math.max(...series[0].data) == 0 ? 0 : 1,
                                },
                            }
                        },
                        data: series[0].data
                    },
                    {
                        name: series[1].name,
                        type: 'line',
                        smooth:true,
                        stack: '总量',
                        symbolSize: 2,
                        showSymbol: false,
                        itemStyle: {
                            normal: {
                              opacity: Math.max(...series[1].data) == 0 ? 0 : 1,
                                color: '#72d8c0',
                                lineStyle: {
                                    color: "#72d8c0",
                                    width: 2,
                                    opacity: Math.max(...series[1].data) == 0 ? 0 : 1,
                                },
                            }
                        },
                        data: series[1].data
                    },
            
                ]
              };
       this.myChart1.setOption(option);
       window.addEventListener("resize", () => {
         if(this.$route.query.identification) {
           var resize = {
             width: this.screenWidth - 21,
           };
           this.myChart1.resize(resize)
         } else {
           this.myChart1.resize()
         }
       })         
    },    
    // 获取工程类型
    getProjectType(){
      let _this = this
      let url = Urls.getEchartsSignedReportDataByEngineeringType
      let params = {
          orgCode:this.orgCode,
          startTime:this.dataRange.length?this.dataRange[0]:'',
          endTime:this.dataRange.length?this.dataRange[1]:'',
          itemCode:'ENGINEERING_TYPE'        
      }
      this.$root.doPost(url,params,function(server_data){
          // 用户没有登录
          if( !_this.$root.isUserLogin(server_data)){
          return;
        }

        // 应用错误
        if(server_data.error){
            _this.$root.showGlobalError(server_data.error);
            return;
        }
        _this.ProjectTypeList = server_data.data
      })      
    },
    // 获取项目类型
    getPieprojectType(){
      let _this = this
      let url = Urls.getEchartsSignedReportDataByProjectType
      let params = {
          orgCode:this.orgCode,
          startTime:this.dataRange.length?this.dataRange[0]:'',
          endTime:this.dataRange.length?this.dataRange[1]:'',
          itemCode:'PROJECT_CATEGORY'         
      }
      this.$root.doPost(url,params,function(server_data){
          // 用户没有登录
          if( !_this.$root.isUserLogin(server_data)){
          return;
        }

        // 应用错误
        if(server_data.error){
            _this.$root.showGlobalError(server_data.error);
            return;
        }
        _this.PieprojectTypeList = server_data.data
      })       
    },
    // 获取合作类型
    getCooperationType(){
      let _this = this
      let url = Urls.getEchartsSignedReportDataByCooperationType
      let params = {
          orgCode:this.orgCode,
          startTime:this.dataRange.length?this.dataRange[0]:'',
          endTime:this.dataRange.length?this.dataRange[1]:'',
          itemCode:'COOPERATION_TYPE'         
      }
      this.$root.doPost(url,params,function(server_data){
          // 用户没有登录
          if( !_this.$root.isUserLogin(server_data)){
          return;
        }

        // 应用错误
        if(server_data.error){
            _this.$root.showGlobalError(server_data.error);
            return;
        }
        _this.CooperationTypeList = server_data.data
      })      
    }, 
    // 获取项目等级
    getProjectLevel(){
      let _this = this
      let url = Urls.getEchartsSignedReportDataByGrade
      let params = {
          orgCode:this.orgCode,
          startTime:this.dataRange.length?this.dataRange[0]:'',
          endTime:this.dataRange.length?this.dataRange[1]:'',
          itemCode:'CONTRACT_LEVEL'         
      }
      this.$root.doPost(url,params,function(server_data){
          // 用户没有登录
          if( !_this.$root.isUserLogin(server_data)){
          return;
        }

        // 应用错误
        if(server_data.error){
            _this.$root.showGlobalError(server_data.error);
            return;
        }
        _this.ProjectLevelList = server_data.data
      })       
    },
    // 获取项目金额排行
    getRankingProjectAmount(){
      let _this = this
      let url = Urls.getEchartsSignedReportDataByProjectMoney
      let params = {
          orgCode:this.orgCode,
          startTime:this.dataRange.length?this.dataRange[0]:'',
          endTime:this.dataRange.length?this.dataRange[1]:'',
          itemCode:''         
      }
      this.$root.doPost(url,params,function(server_data){
          // 用户没有登录
          if( !_this.$root.isUserLogin(server_data)){
          return;
        }

        // 应用错误
        if(server_data.error){
            _this.$root.showGlobalError(server_data.error);
            return;
        }
        _this.RankingProjectAmountList = server_data.data
      })       
    },
    // 获取总监排行榜
    getDirectorRanking(type){
      console.log('type', type)
      let _this = this
      let url
      if(type === 'AMOUNT') {
        url = Urls.getEchartsSignedReportDataByDirectorMoney
      } else {
        url = Urls.getEchartsSignedReportDataByProjectNumber
      }
      let params = {
          orgCode:this.orgCode,
          startTime:this.dataRange.length?this.dataRange[0]:'',
          endTime:this.dataRange.length?this.dataRange[1]:'',
          itemCode:''         
      }
      this.$root.doPost(url,params,function(server_data){
          // 用户没有登录
          if( !_this.$root.isUserLogin(server_data)){
          return;
        }

        // 应用错误
        if(server_data.error){
            _this.$root.showGlobalError(server_data.error);
            return;
        }
        _this.DirectorRankingList = server_data.data
      })       
    },
    // 获取项目地区
    getProjectArea(){
      let _this = this
      let url = Urls.getEchartsSignedReportDataByRegion
      let params = {
          orgCode:this.orgCode,
          startTime:this.dataRange.length?this.dataRange[0]:'',
          endTime:this.dataRange.length?this.dataRange[1]:'',
          itemCode:'PROJECT_REGION'         
      }
      this.$root.doPost(url,params,function(server_data){
          // 用户没有登录
          if( !_this.$root.isUserLogin(server_data)){
          return;
        }

        // 应用错误
        if(server_data.error){
            _this.$root.showGlobalError(server_data.error);
            return;
        }
        _this.ProjectAreaList = server_data.data
      })       
    }
    
  },
  watch:{
    // // 屏幕监听
    // screenWidth(val){
    //   this.initChart()
    // },
    // 合同额
    ContractAmountList(val){
      this.$nextTick(function () {
        var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
        window.dispatchEvent(myEvent); // 事件可以在任何元素触发
      })   
      this.Maxmoney = Math.max(...val.series[0].data,...val.series[1].data)   
      this.initChart()
    },
    // 合同个数
    ContractNumberList(){
      this.$nextTick(function () {
        var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
        window.dispatchEvent(myEvent); // 事件可以在任何元素触发
      })      
      this.initChart1()
    }
  } 
}
</script>

<style lang="scss" scoped>
*{
  margin: 0;
  padding: 0;
}
#signedData{
  #right{
    .inner-top {
      margin-top: 0.29rem;
      display: flex;
      justify-content: space-between;
      .item {
        width: calc(25% - 0.24rem);
        padding: 0.24rem;
        // margin-right: 0.24rem;
        box-sizing: border-box;
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        border-radius: 0.1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &:first-child {
          width: calc(25% - 0.12rem);
        }
        &:last-child {
          // margin-right: 0;
          width: calc(25% - 0.12rem);
        }
        .l-box {
          .l-t {
            font-size: 0.14rem;
            color: #666666;
          }
          .l-a {
            font-size: 0.2rem;
            color: #333333;
            line-height: 0.4rem;
            span {
              font-size: 0.14rem;
            }
          }
        }
        .r-box {
          width: 0.55rem;
          height: 0.55rem;
          img {
            width: 0.55rem;
            height: 0.55rem;
          }
        }
      }
    }
    .ceter-Box{
      margin-top: 0.24rem;
      display: flex;
      justify-content: space-between;
      .left-Box,.right-Box{
        height: 3.96rem;
        width: calc(50% - 0.12rem);
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        border-radius: 0.1rem;
      }
    }
  }
}
@media screen and (max-width: 768px){
  #signedData{
    #right{
      .inner-top {
        flex-direction: column;  
        margin-top: 0.14rem;
        width: 100%;
        padding: 0 0.12rem;
        box-sizing: border-box;
        .item:first-child,.item,.item:last-child{
          width: 100%;
          margin-top: 0.1rem;
        }
        .item:first-child{
          margin-top:0;
        }
      }
      .ceter-Box{
        display: flex;
        flex-direction: column; 
        margin-top: 0.14rem;
        padding: 0 0.12rem;
        box-sizing: border-box;
        .left-Box,.right-Box{
          width: 100%;
          background-color: #fff !important;
        }
        .right-Box{
          margin-top: 0.14rem;
        }
      }
    }
  }
}
@media screen and (max-width: 1366px){
  #signedData{
      #right{
         .inner-top {
          .item {
             .l-box {
               .l-a {
                font-size: 0.16rem;
               }
             }
          }
         }
      }
    }
}
</style>
<style lang="scss">
@media screen and (max-width: 768px){
   #signedData{
    .queryCondition {
      margin-bottom: 0;
    }
   }
}
</style>



// WEBPACK FOOTER //
// signedData.vue?2b885378